import { Flex, Text } from "@chakra-ui/react";
import moment from "moment";
import { Row, Col } from "antd";
import ContentItem from "ui/components/ContentItem";
import { mapFormaPagamentoToLabel } from "infra/helpers/mapFormaPagamentoToLabel";
import { formatPhone } from "infra/helpers/number";
import { OrcamentoCotacaoItemForm } from "features/orcamento/typings";
import { formatMoney } from "infra/helpers/number";
import ListaArquivos from "components/ListaArquivos";

interface DescricaoCotacaoProps {
  item?: OrcamentoCotacaoItemForm;
}

export default function DescricaoCotacao({ item }: DescricaoCotacaoProps) {
  let total = item?.orcamentoCotacaoItems?.reduce(
    (accumulator, currentValue) => accumulator + currentValue.total!,
    0
  );
  return (
    <>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Nome do fornecedor "
            descricao={item?.nomeFornecedor ? item?.nomeFornecedor : "-"}
          />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Telefone"
            descricao={item?.contato ? formatPhone(item?.contato) : "-"}
          />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem titulo="Email" descricao={item?.email ?? "-"} />
        </Flex>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Total"
            fontWeightDescricao="bold"
            descricao={
              item?.valorTotal
                ? formatMoney(item?.valorTotal)
                : formatMoney(total)
            }
          />
        </Flex>
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Data da cotação"
            descricao={
              item?.dataCotacao
                ? moment(item?.dataCotacao).format("DD/MM/YYYY")
                : "-"
            }
          />
        </Flex>

        <Flex as={Col} xs={6}>
          <ContentItem
            titulo="Válido até"
            descricao={
              item?.dataValidade
                ? moment(item?.dataValidade).format("DD/MM/YYYY")
                : "-"
            }
          />
        </Flex>
        <Flex as={Col} xs={12}>
          <ContentItem
            titulo="Forma do pagamento"
            descricao={
              item?.formaPagamentoId
                ? mapFormaPagamentoToLabel(item?.formaPagamentoId)
                : "-"
            }
          />
        </Flex>
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={24}>
          <ContentItem
            titulo="Observação"
            descricao={item?.observacao ?? "--"}
          />
        </Flex>
      </Flex>
      {item?.anexos?.length ? (
        <>
          <Flex>
            <Text fontSize="20px" fontWeight="medium" mb={4}>
              Itens cotados
            </Text>
          </Flex>
          <ListaArquivos
            arquivos={
              item.anexos?.map((anexo) => ({
                referencia:
                  anexo instanceof File
                    ? URL.createObjectURL(anexo)
                    : anexo.referencia,
                nome: anexo instanceof File ? anexo.name : anexo.nome,
              })) || []
            }
          />
        </>
      ) : null}
    </>
  );
}
